import React, { useState, ReactNode, CSSProperties, MouseEventHandler } from 'react';

export type RowProps = {
  leading?: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  trailing?: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
  last?: boolean;
  danger?: boolean;
  style?: CSSProperties;
};

export function Row({
  leading,
  title,
  subtitle,
  trailing,
  onClick,
  last,
  danger,
  style,
}: RowProps) {
  const [hover, setHover] = useState(false);
  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={onClick}
      style={{
        display: 'flex', alignItems: 'center', gap: 12,
        padding: '12px 16px', minHeight: 'var(--row-h)',
        background: hover && onClick ? 'var(--bg-fill-1)' : 'transparent',
        cursor: onClick ? 'pointer' : 'default',
        borderBottom: last ? 'none' : '1px solid var(--line-divider)',
        transition: 'background var(--dur-fast) var(--ease-out)',
        ...style,
      }}
    >
      {leading && (
        <div
          style={{
            display: 'flex', alignItems: 'center',
            color: danger ? 'var(--danger)' : 'var(--fg-secondary)',
          }}
        >
          {leading}
        </div>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: 15, fontWeight: 500,
            color: danger ? 'var(--danger)' : 'var(--fg-primary)',
            letterSpacing: '-0.2px',
          }}
        >
          {title}
        </div>
        {subtitle && (
          <div className="t-footnote" style={{ color: 'var(--fg-tertiary)', marginTop: 2 }}>
            {subtitle}
          </div>
        )}
      </div>
      {trailing && (
        <div
          style={{
            display: 'flex', alignItems: 'center',
            color: 'var(--fg-tertiary)', gap: 6,
          }}
        >
          {trailing}
        </div>
      )}
    </div>
  );
}

export default Row;
